import React from "react";
import { Row, Col, Image } from "antd";
import { Link } from "react-router-dom";
import {
  PhoneOutlined,
  MailOutlined,
  TwitterOutlined,
  FacebookOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";

export const FooterView = () => {
  return (
    <div className='footer'>
      <Row justify="space-around" align="middle">
        <Col xs={24} sm={12} md={6} className="footer-seims-helpdesk">
          <div>
            <h3 className='contact-text'>SEIMS Help Desk</h3>
            
            <div>
              <MailOutlined /> &nbsp; seims.helpdesk@saasta.nrf.ac.za
            </div>
          </div>
        </Col>
        <Col xs={24} sm={12} md={6} className="footer-dsi">
          <div>
            <h3 className='contact-text'>DSTI Contact Details</h3>
            
            <div>
              <MailOutlined /> &nbsp; livhuwani.masevhe@dsti.gov.za
            </div>
            <div>
              <a href="https://x.com/dstigovza" target="_blank">
              <div className="twitter-holder"><Image
                src={require("../../assets/twitter.png")}
                alt="Events Tracker"
                style={{ maxWidth: "18px", marginTop:"0px"}}
                preview={false}
              /></div>
              </a>
              <a href="https://www.facebook.com/dstigovza/" target="_blank">
                <FacebookOutlined style={{ marginRight: "10px" }} />
              </a>
              <a href="https://www.youtube.com/@DSTIGOVZA" target="_blank">
                <YoutubeOutlined />
              </a>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <div>
            <h3 className='contact-text'>SAASTA Contact Details</h3>
            
            <div>
              <MailOutlined /> &nbsp; bm.kgwadi@saasta.nrf.ac.za
            </div>
            <div>
            <a href="https://x.com/NRF_SAASTA" target="_blank">
              <div className="twitter-holder"><Image
                src={require("../../assets/twitter.png")}
                alt="Events Tracker"
                style={{ maxWidth: "18px", marginTop:"0px"}}
                preview={false}
              /></div>
              </a>
              <a href="https://facebook.com/NRFSAASTA/" target="_blank">
                <FacebookOutlined style={{ marginRight: "10px" }} />
              </a>
              <a href="https://www.youtube.com/@SAHumangenome" target="_blank">
                <YoutubeOutlined />
              </a>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={12}  md={6} className="footer-quick-links">
          <div>
            <h3 className='contact-text'>Quick Links</h3>
            <div>
              <Link to="/privacy-statement">Privacy Policy</Link>
            </div>
            <div>
              <Link to="/terms-and-conditions">Terms and Conditions</Link>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
